export default "__VITE_ASSET__BOwLIjvZ__"